import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ArrowRightIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${styles.arrowRightIcon} ${className}`}
        data-testid={testId}
        fill="none"
        strokeWidth="1.9"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 6L15 12L9 18"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.9"
        ></path>
    </svg>
);

export default ArrowRightIcon;
